import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "../../../../../../../components/MessageWithLink/types";

export enum TaxableBenefits {
  CAR = "Car",
  COMMUTER_ALLOWANCE = "Commuter allowance",
  LIVING_ACCOMMODATION = "Living accommodation",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal allowance",
  MEDICAL_INSURANCE = "Medical insurance",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  PHONE_AND_INTERNET = "Phone & internet",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
  REMOTE_WORK = "Remote work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.MEAL_ALLOWANCE]: {
    text: "Tax-exempt up to €1,800 per year if backed by meal receipts/invoices. Otherwise, tax-exempt up to €1,200 per year if paid as a cash allowance without invoices.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.MEDICAL_INSURANCE]: {
    text: "Tax-exempt up to €500 per year for employer-paid supplementary health insurance premiums.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.NONCASH_GIFT_AND_AWARDS]: {
    text: "Tax-exempt up to €700 per year combined.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
  [TaxableBenefits.REMOTE_WORK]: {
    text: "Tax-Exempt up to €4 per day, maximum of €70 per month.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
